import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import CampaignNameParams from './CampaignNameParams';

const mapStateToProps = (state: any) => ({
  settings: state.trackerSettings.global.settings,
  isLoading: state.trackerSettings.global.isLoading,
  failed: state.trackerSettings.global.failed,
});

export const ConnectedCampaignNameParams = connect(
  mapStateToProps, null,
)(CampaignNameParams);

export default withTranslation(['administration'])(ConnectedCampaignNameParams as any);
